<style lang="scss">
 .booking-slot-stats{
    ul{
      list-style: none;

      li {
        cursor: pointer;
        border-bottom-color: transparent;

        &.active {
          font-weight: bold;
          border-bottom-color:  #7B2DA4;
        }
      }
    }
 }
</style>

<template>
    <section class="ui-stats-item booking-slot-stats">
      <div class="col-12">

        <h4 class="font-weight-bold text-center title-divider top-divider">Shows booking slot usage for the last {{filters.days}} days</h4>

        <div style="min-height: 350px">
          <section class="booking-slot-stats__items mt-4"  v-if="!loadingStats">
            <p class="brand-color font-weight-bold mb-5 text-right">Total Utilization rate for all slots: {{totalUtilizationRate}}</p>

            <section class="booking-slot-stats-day-blocks">
              <ul class="d-inline-flex justify-content-between text-center full-width">
                <li @click="setDaySlotData(day)" :class="{'active': activeDay === day}"
                    class="text-capitalize title-divider" :key="day" v-for="day in weekDays">{{day}}</li>
              </ul>

              <booking-slot-day @new-day="activeDay = day" :day-slot-data="daySlotData" :active-day="activeDay"></booking-slot-day>
            </section>

            <div class="col-12 mt-4" v-if="!loadingChart">
              <bar-chart-simple :key="2" y-title="Number of calls"
                                x-title="Booking Slots"
                                :title="'Total Bookings for ' + activeDay + ' slots over last ' + filters.days + ' Days'"
                                max-width="600px" chart-id="chartDay" :series="chartDaySimple"></bar-chart-simple>
            </div>
          </section>

          <section v-else class="d-flex justify-content-center pb-4 pt-5 flex-wrap">
            <p class="full-width d-flex justify-content-center">Getting Stats...</p>
            <b-spinner variant="primary"></b-spinner>
          </section>
        </div>
      </div>
    </section>
</template>

<script>
  import VisitsService from '../../../services/VisitService';
  import HelperService from '../../../services/HelperService';
  import BookingSlotDay from './bookingSlots/BookingSlotDay';
  import BookingSlotCalculations from './bookingSlots/BookingSlotCalculations';
  import BarChartSimple from '@/components/charts/BarChartSimple';

  export default {
    name: 'booking-slot-stats',
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    components: {
      BookingSlotDay,
      BarChartSimple,
    },
    watch: {
      filters: {
        handler() {
          this.getBookingSlotStats();
        },
        deep: true,
      },
      activeChart() {
        this.delayChartRender();
      }
    },
    data() {
      return {
        slotHelpers: new BookingSlotCalculations(),
        helperService: new HelperService(),
        loadingStats: true,
        stats: null,
        weekDays: [],
        activeDay: 'monday',
        daySlotData: [],
        totalUtilizationRate: '',
        loadingChart: false,
        chartDaySimple: null,
      };
    },
    mounted() {
      this.getBookingSlotStats();
      this.weekDays = this.helperService.getWeekdays();
    },
    methods: {
      getBookingSlotStats() {
        return VisitsService.getBookingSlotUsageStats(this.filters).then((res) => {
          this.stats = res.data.booking_slots;
          this.setDaySlotData(this.activeDay);
          this.totalUtilizationRate = this.slotHelpers.calculateTotalUtilizationForSlots(this.stats);
        }).catch((err) => {
          console.log('could not get call stats', err);
          this.$toasted.error('Error getting call stats, please refresh and try again');
        }).finally(() => {
          setTimeout(() => {
            this.loadingStats = false;
          }, 1000);
        });
      },
      delayChartRender() {
        this.loadingChart = true;

        setTimeout(() => {
          this.loadingChart = false;
        }, 500);
      },
      setDaySlotData(day) {
        this.activeDay = day;

        this.daySlotData = this.stats.filter((slot) => {
          return slot.weekday.toLowerCase() === day;
        });

        this.chartDaySimple = this.setDayChartDataSimple();
        this.delayChartRender();
      },
      setDayChartDataSimple() {
        let chart = {
          data: [],
          labels: [],
        };

        const dayData = this.daySlotData;

        dayData.forEach((slot) => {
          chart.data.push(slot.bookings);
          chart.labels.push(slot.name);
        });

        return chart;
      },
    },
  };
</script>
